import BaseService from "./geral/BaseService";
import {objetoParaQueryString} from "../utils/formatar";
import {urlApi} from "../config/Constantes";

const cntrConsulta = "AgendCntrConsulta";
const base = "LiberacaoImportacao"

export default class ImportacaoService extends BaseService {
    constructor() {
        super(cntrConsulta);
    };

    listar(filtro) {
        let str = objetoParaQueryString(filtro);
        return super.httpGet(`/${cntrConsulta}/Pesquisar?${str}`);
    };

    listaProtocolos(dataInicial, dataFinal, bl, numeroCe, situacao, operacao){
        let filtros = "?";
        if (dataInicial) filtros = filtros.concat(`dataInicial=${dataInicial}`);
        if (dataFinal) filtros = filtros.concat(`&dataFinal=${dataFinal}`);
        if (bl) filtros = filtros.concat(`&bl=${bl}`);
        if (numeroCe) filtros = filtros.concat(`&numeroCe=${numeroCe}`);
        if (operacao) filtros = filtros.concat(`&operacao=${operacao}`);
        if (situacao) filtros = filtros.concat(`&statusId=${situacao}`);
        filtros = filtros.replace("?&", "?");
        return super.httpGet(`/${base}/ListarProtocolos${filtros}`)
    };

    listarNavios = () => {
        return super.httpGet(`/${base}/ListarOperacoes`);
    };

    buscarDetalhes = (blId, blNbr, protocoloId) => {
        return super.httpGet(`/${base}/CarregarInfosPrincipaisBl/${blId}/${blNbr}/${protocoloId}`);
    };

    listarTiposDocumento = (blId, tipoProcesso) => {
        return super.httpGet(`/${base}/ListarTiposDocumento/${blId}/${tipoProcesso}`);
    };

    listarTipoProcesso = (blId) => {
        return super.httpGet(`/${base}/ListarTipoProcesso`);
    };
    
    listarProtocolos = (blId, bl, dtInicial, dtFinal, operacao, statusId, numCe) => {
        return super.httpGet(`/${base}/ListarProtocolos?blId=${blId}&bl=${bl}&dataInicial=${dtInicial}&dataFinal=${dtFinal}&operacao=${operacao}&statusId=${statusId}&numeroCe=${numCe}`);
    };

    listarTipoRetiradaCarga = (blId) => {
        return super.httpGet(`/${base}/ListarTipoRetiradaCarga`);
    };

    listarTipoNfe = () => {
        return super.httpGet(`/${base}/ListarTipoNfe`);
    };

    enviarPraAnalise = (protocoloId) => {
        return super.httpGet(`/${base}/EnviarParaAnalise/${protocoloId}`);
    };

    salvarNota = (tipoServico, chaveAcessoNf, blId, protocoloId,tipoNota = 'MAE') => {
        return super.httpPost(`/${base}/InserirChaveAcessoNf/${tipoServico}/${chaveAcessoNf}/${blId}/${protocoloId}/${tipoNota}`);
    };

    buscarDocumento = (infDocId) => {
        return `${urlApi}/${base}/DownloadDocumento/${infDocId}`;
    };

    inativarDocumento = (docInfId, protocoloId) => {
        return super.httpGet(`/${base}/InativarDocumento?docInfId=${docInfId}&protocoloId=${protocoloId}`);
    };

    salvarEmail = (email, blId) => {
        return super.httpGet(`/${base}/SalvarEmail/${email}/${blId}`);
    };

    alterarTipoProtocolo = (tipoProtocolo, protocoloId) => {
        return super.httpGet(`/${base}/AlterarTipoProtocolo/${tipoProtocolo}/${protocoloId}`);
    };

    desistirVistoria = (docId) => {
        return super.httpGet(`/${base}/DesistirVistoriaSsa?docId=${docId}`);
    }
    
    gerarProtocoloFilho = (protocId) => {
        return super.httpGet(`/${base}/GerarProtocoloFilho?protocoloId=${protocId}`);
    }
    
    salvarDocumento(doc, dado, criarFilho = "N") {
        let filtros = "?";
        let extensao = null
        if (dado.extensao) 
            extensao = dado.dscArquivo.split('.').pop();
         
        filtros = filtros.concat(`extensao=${extensao}`);    
        if (dado.tipoDocId) filtros = filtros.concat(`&tipoDocId=${dado.tipoDocId.value}`);
        
        filtros = filtros.concat(`&numDoc=${dado.numDoc}`)
        if (dado.dscArquivo) filtros = filtros.concat(`&dscArquivo=${dado.dscArquivo}`);
        if (dado.blId) filtros = filtros.concat(`&blId=${dado.blId}`);
        if (dado.protocoloId) filtros = filtros.concat(`&protocoloId=${dado.protocoloId}`);
        filtros = filtros.concat(`&criarFilho=${criarFilho}`);
        filtros = filtros.replace("?&", "?");

        return super.httpPost(`/${base}/SalvarDocumento${filtros}`, doc)
    };
}


// WEBPACK FOOTER //
// ./src/services/ImportacaoService.js